import { BaseAPIModel } from '@weezevent/weezjs-core';

export class RejectedEmail extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl(params) {
        return `/mail/rejected-email/${params.email}`;
    }
}
